import { ObjectSchema } from './object_schema';

export class IntegrationModel extends ObjectSchema {
  integration_name: string;
}
